import React, { useEffect, useState } from 'react';
import gsap from '../lib/gsap';

interface SplashProps {
  onComplete: () => void;
}

const Splash: React.FC<SplashProps> = ({ onComplete }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Complete loading after 2 seconds
    const completeTimeout = setTimeout(() => {
      // Animate out
      gsap.to('.splash-container', {
        opacity: 0,
        scale: 1.1,
        duration: 0.8,
        ease: "power2.inOut",
        onComplete: () => {
          setIsVisible(false);
          onComplete();
        }
      });
    }, 2000);

    return () => {
      clearTimeout(completeTimeout);
    };
  }, [onComplete]);

  // Animate in on mount
  useEffect(() => {
    gsap.fromTo('.splash-container', 
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 0.6, ease: "power2.out" }
    );
  }, []);

  if (!isVisible) return null;

  return (
    <div className="splash-container fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-primary to-dark">
      {/* 10concept Logo */}
      <div className="relative">
        <img 
          src="/logos/10concept-logo.png"
          alt="10concept Logo"
          className="w-32 sm:w-48 md:w-64 lg:w-80 h-auto opacity-90"
        />
      </div>
    </div>
  );
};

export default Splash;
